import React, { useState, useEffect } from 'react'
import { T, Avatar, SectionLabel, probColor, playColor } from './ui'
import { getNFLPrimeSpots } from './api'
import { playText, teamNick } from './plain'

// Prime Spots — a player in a "prime spot for a big game": several independent tailwinds
// stacked on ONE market (model lean + soft matchup + scoring game + priced edge). Graded
// per market server-side, so a target-hog TE lights up on receptions while his TD stays cool.

const TIER_STYLE = {
  'SMASH':  { label: 'SMASH',  bg: T.green,                 fg: '#04140D', bd: null },
  'PRIME+': { label: 'PRIME+', bg: 'rgba(0,217,126,.2)',   fg: T.green,   bd: T.greenMid },
  'PRIME':  { label: 'PRIME',  bg: 'rgba(245,165,36,.16)', fg: T.amber,   bd: 'rgba(245,165,36,.5)' },
}

export function PrimeBadge({ tier, size = 'md' }) {
  const s = TIER_STYLE[tier] || TIER_STYLE.PRIME
  const sm = size === 'sm'
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontWeight: 900,
      fontSize: sm ? 10 : 11, letterSpacing: '0.03em', color: s.fg, background: s.bg,
      border: s.bd ? `1px solid ${s.bd}` : 'none', borderRadius: 7, padding: sm ? '1px 6px' : '2px 8px', flexShrink: 0 }}>
      🔥 {s.label}
    </span>
  )
}

function PrimeRow({ e, onOpen }) {
  return (
    <button onClick={() => onOpen && onOpen(e)} style={{ display: 'flex', width: '100%', textAlign: 'left',
      alignItems: 'center', gap: 11, cursor: onOpen ? 'pointer' : 'default', color: T.text,
      background: `linear-gradient(100deg, ${T.greenDim}, ${T.card})`, border: `1px solid ${T.greenMid}`,
      borderRadius: 12, padding: '11px 13px', marginBottom: 8 }}>
      <Avatar url={e.headshot} name={e.name} team={e.team} size={34} />
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
          <span style={{ fontSize: 14, fontWeight: 800, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0 }}>{e.name}</span>
          <PrimeBadge tier={e.tier} size="sm" />
        </div>
        <div style={{ fontSize: 11, color: T.muted, marginTop: 1 }}>
          {playText(e.market_key || e.market, e.line)} · {e.pos} vs {teamNick(e.opp)}
        </div>
        <div style={{ fontSize: 10.5, color: T.faint, marginTop: 3, lineHeight: 1.35 }}>
          {(e.reasons || []).join(' · ')}
        </div>
      </div>
      <div style={{ fontFamily: T.mono, fontWeight: 900, fontSize: 17, color: playColor((e.prob || 0) / 100, e), minWidth: 42, textAlign: 'right', flexShrink: 0 }}>
        {Math.round(e.prob)}%
      </div>
    </button>
  )
}

export default function PrimeSpots({ season = 2026, week = 1, onPlayer, limit = 6, showLabel = true }) {
  const [d, setD] = useState(null)
  useEffect(() => { let a = true; setD(null)
    getNFLPrimeSpots(season, week, '', 20).then(r => { if (a) setD(r) }).catch(() => { if (a) setD({ spots: [] }) })
    return () => { a = false } }, [season, week])
  if (!d) return null
  const spots = (d.spots || []).slice(0, limit)
  if (spots.length < 2) return null
  return (
    <>
      {showLabel && <SectionLabel>🔥 Prime Spots · the week's smash setups</SectionLabel>}
      <div style={{ fontSize: 10.5, color: T.muted, margin: '0 2px 8px', lineHeight: 1.5 }}>
        Where our model, the matchup, and the game total <b style={{ color: T.text }}>all line up</b> on one market — the real "big game" spots.
      </div>
      {spots.map((e, i) => <PrimeRow key={`prime-${i}`} e={e} onOpen={onPlayer} />)}
    </>
  )
}
